"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StargateClient = exports.isBroadcastTxSuccess = exports.isBroadcastTxFailure = exports.TimeoutError = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
var encoding_1 = require("@cosmjs/encoding");
var tendermint_rpc_1 = require("@cosmjs/tendermint-rpc");
var utils_1 = require("@cosmjs/utils");
var TimeoutError = /** @class */ (function (_super) {
    __extends(TimeoutError, _super);
    function TimeoutError(message, txId) {
        var _this = _super.call(this, message) || this;
        _this.txId = txId;
        return _this;
    }
    return TimeoutError;
}(Error));
exports.TimeoutError = TimeoutError;
function isBroadcastTxFailure(result) {
    return result.code != 0;
}
exports.isBroadcastTxFailure = isBroadcastTxFailure;
function isBroadcastTxSuccess(result) {
    return result.code == 0;
}
exports.isBroadcastTxSuccess = isBroadcastTxSuccess;
var StargateClient = /** @class */ (function () {
    function StargateClient(tmClient) {
        if (tmClient) {
            this.tmClient = tmClient;
        }
    }
    StargateClient.connect = function (endpoint) {
        return __awaiter(this, void 0, void 0, function () {
            var tmClient;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, tendermint_rpc_1.Tendermint34Client.connect(endpoint)];
                    case 1:
                        tmClient = _a.sent();
                        return [2 /*return*/, new StargateClient(tmClient)];
                }
            });
        });
    };
    StargateClient.prototype.getTmClient = function () {
        return this.tmClient;
    };
    StargateClient.prototype.forceGetTmClient = function () {
        if (!this.tmClient) {
            throw new Error("Tendermint client not available. You cannot use online functionality in offline mode.");
        }
        return this.tmClient;
    };
    StargateClient.prototype.getTx = function (id) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var results;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.txsQuery("tx.hash='" + id + "'")];
                    case 1:
                        results = _b.sent();
                        return [2 /*return*/, (_a = results[0]) !== null && _a !== void 0 ? _a : null];
                }
            });
        });
    };
    StargateClient.prototype.disconnect = function () {
        if (this.tmClient)
            this.tmClient.disconnect();
    };
    StargateClient.prototype.broadcastTx = function (tx, timeoutMs, pollIntervalMs) {
        if (timeoutMs === void 0) { timeoutMs = 60000; }
        if (pollIntervalMs === void 0) { pollIntervalMs = 3000; }
        return __awaiter(this, void 0, void 0, function () {
            var timedOut, txPollTimeout, pollForTx, test, broadcasted, transactionId;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        timedOut = false;
                        txPollTimeout = setTimeout(function () {
                            timedOut = true;
                        }, timeoutMs);
                        pollForTx = function (txId) { return __awaiter(_this, void 0, void 0, function () {
                            var result;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (timedOut) {
                                            throw new TimeoutError("Transaction with ID " + txId + " was submitted but was not yet found on the chain. You might want to check later.", txId);
                                        }
                                        return [4 /*yield*/, utils_1.sleep(pollIntervalMs)];
                                    case 1:
                                        _a.sent();
                                        return [4 /*yield*/, this.getTx(txId)];
                                    case 2:
                                        result = _a.sent();
                                        return [2 /*return*/, result
                                                ? {
                                                    code: result.code,
                                                    height: result.height,
                                                    rawLog: result.rawLog,
                                                    transactionHash: txId,
                                                    gasUsed: result.gasUsed,
                                                    gasWanted: result.gasWanted,
                                                }
                                                : pollForTx(txId)];
                                }
                            });
                        }); };
                        return [4 /*yield*/, this.forceGetTmClient().status()];
                    case 1:
                        test = _a.sent();
                        return [4 /*yield*/, this.forceGetTmClient().broadcastTxSync({ tx: tx })];
                    case 2:
                        broadcasted = _a.sent();
                        if (broadcasted.code) {
                            throw new Error("Broadcasting transaction failed with code " + broadcasted.code + " (codespace: " + broadcasted.codeSpace + "). Log: " + broadcasted.log);
                        }
                        transactionId = encoding_1.toHex(broadcasted.hash).toUpperCase();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                return pollForTx(transactionId).then(function (value) {
                                    clearTimeout(txPollTimeout);
                                    resolve(value);
                                }, function (error) {
                                    clearTimeout(txPollTimeout);
                                    reject(error);
                                });
                            })];
                }
            });
        });
    };
    StargateClient.prototype.txsQuery = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var results;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.forceGetTmClient().txSearchAll({ query: query })];
                    case 1:
                        results = _a.sent();
                        return [2 /*return*/, results.txs.map(function (tx) {
                                return {
                                    height: tx.height,
                                    hash: encoding_1.toHex(tx.hash).toUpperCase(),
                                    code: tx.result.code,
                                    rawLog: tx.result.log || "",
                                    tx: tx.tx,
                                    gasUsed: tx.result.gasUsed,
                                    gasWanted: tx.result.gasWanted,
                                };
                            })];
                }
            });
        });
    };
    return StargateClient;
}());
exports.StargateClient = StargateClient;
